<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      sort-by="calories"
      class="elevation-1"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      :search="search"
      @page-count="pageCount = $event"
    >
      <template v-slot:item.status="{ item }">
        <v-chip
          :color="getColor(item.status)"
          dark
        >
          {{ item.status }}
        </v-chip>
      </template>
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>推广数据</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            clearable
            single-line
            hide-details
          />
          <v-spacer />
          <v-dialog
            v-model="dialog"
            max-width="0px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                添加
              </v-btn>
            </template>
            <validation-observer
              ref="observer"
              v-slot="{ invalid }"
            >
              <form @submit.prevent="submit">
                <v-card>
                  <v-card-text>
                    <v-container>
                      <v-row justify="center">
                        <v-dialog
                          v-model="dialog"
                          fullscreen
                          hide-overlay
                          transition="dialog-bottom-transition"
                        >
                          <v-card>
                            <v-toolbar
                              dark
                              color="primary"
                            >
                              <v-btn
                                icon
                                dark
                                @click="dialog = false"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                              <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                              <v-spacer />
                              <v-toolbar-items>
                                <v-btn
                                  dark
                                  color="success"
                                  type="submit"
                                  :disabled="invalid"
                                  @click="sava"
                                >
                                  保存
                                </v-btn>
                              </v-toolbar-items>
                            </v-toolbar>
                            <v-divider />
                            <v-card
                              class="mb-12"
                              color="red lighten-5"
                            >
                              <v-row
                                class="spacing-playground pa-6"
                              >
                                <v-col
                                  cols="24"
                                  md="12"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="渠道来源"
                                  >
                                    <v-radio-group
                                      v-model="editedItem.source"
                                      :error-messages="errors"
                                      mandatory
                                      row
                                      label="渠道来源"
                                    >
                                      <v-radio
                                        v-for="(item, i) in sourceList"
                                        :key="i"
                                        :label="item.label"
                                        :value="item.value"
                                      />
                                    </v-radio-group>
                                  </validation-provider>
                                </v-col>
                                <v-col
                                  cols="24"
                                  md="12"
                                >
                                  <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <validation-provider
                                        v-slot="{ errors }"
                                        name="备注"
                                        rules="required"
                                      >
                                        <v-text-field
                                          v-model="editedItem.extension_date"
                                          label="推广日期"
                                          :error-messages="errors"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                        />
                                      </validation-provider>
                                    </template>
                                    <v-date-picker
                                      v-model="editedItem.extension_date"
                                      locale="zh-cn"
                                      @input="menu2 = false"
                                    />
                                  </v-menu>
                                </v-col>
                                <v-spacer />
                                <v-col
                                  cols="24"
                                  md="6"
                                >
                                  <v-text-field
                                    v-model="editedItem.extension_am"
                                    label="推广时间AM"
                                  />
                                </v-col>
                                <v-spacer />
                                <v-col
                                  cols="24"
                                  md="6"
                                >
                                  <v-text-field
                                    v-model="editedItem.extension_pm"
                                    label="推广时间PM"
                                  />
                                </v-col>
                                <v-spacer />
                                <v-col
                                  cols="24"
                                  md="3"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="展现"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.views"
                                      :error-messages="errors"
                                      :counter="10"
                                      label="展现"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />
                                <v-col
                                  cols="24"
                                  md="3"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="点击"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.click"
                                      :error-messages="errors"
                                      label="点击"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />
                                <!--<v-col
                                  cols="24"
                                  md="3"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="平均点击价格"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.average"
                                      :error-messages="errors"
                                      :counter="10"
                                      label="平均点击价格"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />
                                <v-col
                                  cols="24"
                                  md="3"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="点击率"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.click_rate"
                                      :error-messages="errors"
                                      :counter="10"
                                      label="点击率"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />-->
                                <v-col
                                  cols="24"
                                  md="3"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="消费"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.quota"
                                      :error-messages="errors"
                                      :counter="10"
                                      label="消费"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />
                                <!--<v-col
                                  cols="24"
                                  md="3"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="咨询成本"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.consulting"
                                      :error-messages="errors"
                                      :counter="10"
                                      label="咨询成本"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />
                                <v-col
                                  cols="24"
                                  md="3"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="线索成本"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.clue"
                                      :error-messages="errors"
                                      :counter="10"
                                      label="线索成本"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />
                                <v-col
                                  cols="24"
                                  md="3"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="意向客户成本"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.potential"
                                      :error-messages="errors"
                                      :counter="10"
                                      label="意向客户成本"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />
                                <v-col
                                  cols="24"
                                  md="6"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="有效约见成本"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.effective"
                                      :error-messages="errors"
                                      :counter="10"
                                      label="有效约见成本"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />-->
                                <v-col
                                  cols="24"
                                  md="3"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="总咨询"
                                    rules="required"
                                  >
                                    <v-text-field
                                      v-model="editedItem.consulting_total"
                                      :error-messages="errors"
                                      :counter="10"
                                      label="总咨询"
                                      required
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-spacer />
                                <v-col
                                  cols="24"
                                  md="12"
                                >
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="备注"
                                  >
                                    <v-textarea
                                      v-model="editedItem.remarks"
                                      :error-messages="errors"
                                      label="备注"
                                      rows="3"
                                    />
                                  </validation-provider>
                                </v-col>
                                <v-col
                                  cols="24"
                                  md="12"
                                >
                                  <v-alert
                                    outlined
                                    type="info"
                                  >
                                    填写信息后，点击右上角的【保存】提交
                                  </v-alert>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-card>
                        </v-dialog>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </form>
            </validation-observer>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="300px"
          >
            <v-card>
              <v-card-title
                class="headline"
              >
                请确认是否删除?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  取消
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  确定
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template
        v-slot:item.actions="{ item }"
      >
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
      />
      <!--<v-text-field
        :value="itemsPerPage"
        label="Items per page"
        type="number"
        min="-1"
        max="15"
        @input="itemsPerPage = parseInt($event, 10)"
      />-->
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { required } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
  extend('required', {
    ...required,
    message: '{_field_} 不能为空',
  })

  export default {
    name: 'MarketingView',
    components: {
      ValidationObserver,
      ValidationProvider,
    },
    data: () => ({
      menu2: false,
      search: '',
      dialog: false,
      dialogDelete: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 12,
      roleList: [],
      headers: [
        { text: '推广日期', value: 'extension_date', width: '120' },
        { text: '推广时间', value: 'extension_time', sortable: false, width: '150' },
        { text: '渠道来源', value: 'source_name', width: '150' },
        { text: '展现', value: 'views', width: '90' },
        { text: '点击', value: 'click', width: '90' },
        { text: '平均点击价格', value: 'average', sortable: false, width: '150' },
        { text: '点击率', value: 'click_rate', width: '120' },
        { text: '消费', value: 'quota', sortable: false, width: '120' },
        { text: '电话客户咨询', value: 'remarks', width: '180' },
        { text: '商桥客户咨询', value: 'remarks', width: '180' },
        { text: '网站留电', value: 'remarks', width: '150' },
        { text: '总咨询量', value: 'remarks', width: '150' },
        { text: '线索', value: 'remarks', sortable: false, width: '90' },
        { text: '无效', value: 'remarks', sortable: false, width: '90' },
        { text: '待定', value: 'remarks', sortable: false, width: '90' },
        { text: '有效约见', value: 'remarks', sortable: false, width: '120' },
        { text: '意向总和', value: 'remarks', sortable: false, width: '120' },
        { text: '咨询成本', value: 'consulting', sortable: false, width: '150' },
        { text: '线索成本', value: 'clue', sortable: false, width: '150' },
        { text: '总咨询', value: 'consulting_total', sortable: false, width: '150' },
        { text: '意向客户成本', value: 'potential', sortable: false, width: '150' },
        { text: '有效约见成本', value: 'effective', sortable: false, width: '150' },
        { text: '操作', value: 'actions', sortable: false, width: '100' },
      ],
      desserts: [],
      editedIndex: -1,
      sourceList: [],
      sourceArr: [],
      editedItem: {
        source: 19,
        extension_date: new Date().toISOString().substr(0, 10),
        extension_am: '9:00-12:00',
        extension_pm: '14:00-18:00',
        views: '',
        click: '',
        average: '¥',
        click_rate: '',
        quota: '¥',
        consulting: '¥',
        clue: '¥',
        potential: '¥',
        effective: '¥',
        remarks: '',
        consulting_total: '',
      },
      defaultItem: {
        source: 19,
        extension_date: new Date().toISOString().substr(0, 10),
        extension_am: '9:00-12:00',
        extension_pm: '14:00-18:00',
        views: '',
        click: '',
        average: '¥',
        click_rate: '',
        quota: '¥',
        consulting: '¥',
        clue: '¥',
        potential: '¥',
        effective: '¥',
        remarks: '',
        consulting_total: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? '录入推广数据' : '修改推广数据'
      },
    },

    watch: {
      dialog (val) {
        if (val === true) {
          if (this.editedIndex === -1) {
            // this.roles = 'sale'
          }
        }
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // 获取来源列表
        axios
          .post(process.env.VUE_APP_BASE_API + '/classify/get_sub/2')
          .then(response => {
            if (response.data.code === 20000) {
              response.data.data.map((item, i, arr) => {
                this.sourceList[i] = { value: item.id, label: item.name }
                this.sourceArr[item.id] = item.name
              })
            }
          })
          .catch(error => {
            console.log(error)
          })
        // get
        axios
          .get(process.env.VUE_APP_BASE_API + '/marketing/list')
          .then(response => {
            if (response.status === 200) {
              this.desserts = response.data.data.data
              this.desserts.map((item, i, arr) => {
                item.extension_time = '上午：' + item.extension_am + '\n\r' + '下午：' + item.extension_pm
                item.source_name = this.sourceArr[item.source]
              })
              // console.log(this.desserts)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        // console.log(this.editedItem)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        axios
          .delete(process.env.VUE_APP_BASE_API + '/marketing/destroy/' + this.editedItem.id)
          .then(response => {
            if (response.data.code === 20000) {
              this.desserts.splice(this.editedIndex, 1)
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      sava () {
        this.$refs.observer.validate()
        if (this.editedItem.source !== '' && this.editedItem.extension_date !== '') {
          const item = this.editedItem
          const _editedIndex = this.editedIndex
          const url = this.editedIndex === -1 ? process.env.VUE_APP_BASE_API + '/marketing/create' : process.env.VUE_APP_BASE_API + '/marketing/update/' + item.id
          axios
            .post(url, this.editedItem)
            .then(response => {
              if (response.data.code === 20000) {
                item.source_name = this.sourceArr[item.source]
                item.extension_time = '上午：' + item.extension_am + '\n\r' + '下午：' + item.extension_pm
                item.id = response.data.id
                if (_editedIndex > -1) {
                  Object.assign(this.desserts[_editedIndex], item)
                } else {
                  this.desserts.push(item)
                }
              }
            })
            .catch(error => {
              console.log(error)
            })
          this.close()
        }
      },

      getColor (calories) {
        if (calories === '无效' || calories === '输单') return 'red'
        else return 'green'
      },

    },
  }
</script>
